import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Must be imported before App - patches window.fetch to attach the
// auth token to every API call and handle 401s globally.
import './utils/authFetch';

// Applies any previously-saved theme color (see utils/theme.js /
// pages/ThemeSettings.js) immediately, before the first render, so
// there's no flash of the default blue before it switches over.
import { initTheme } from './utils/theme';

import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

initTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
